<template>
  <div>
    <b-row v-show="geogrid.obfuscatedId && showOnMapComponents && pageTab === 'show'" class='inmap top left'>
      <b-col xs=4 class='pl-0'>
        <button @click="repeatGeogrid(geogrid)" class="btn btn-secondary btn-sm">
          <span class='wrap-icon'><i class="far fa-repeat" /></span>
          <span class='text'>Repeat</span>
        </button>
        <buttonGetGeogridImage
          ref="buttonGetGeogridImage"
          classes='btn btn-sm'
          :geogrid='geogrid'
          :with-text="true" />
        <a :href='`${geogridsPath}/${geogrid.obfuscatedId}/csv_export`'
          class="btn btn-secondary btn-sm" data-turbolinks="false">
          <span class='wrap-icon'><i class='far fa-file-csv' /></span>
          <span class='text'>CSV</span>
        </a>
        <buttonCopyLinkToClipboard
          :link='geogrid.url'
          classes='button-copy'
          text-button="Copy link" />
        <button @click="deleteGeogrid(geogrid.obfuscatedId)" class="btn btn-secondary btn-sm delete">
          <span class='wrap-icon'><i class="far fa-trash" /></span>
          <span class='text'>Delete</span>
        </button>
      </b-col>
    </b-row>
    <div class='inmap top right vertical'>
      <button @click='toggleOnMapComponents' v-show="geogrid.obfuscatedId && pageTab === 'show'" class='btn w-100'>
        <span class='wrap-icon'>
          <i :class="{'far fa-eye-slash': !showOnMapComponents, 'far fa-eye': showOnMapComponents}" />
        </span>
      </button>
    </div>
    <div class='inmap bottom right vertical'>
      <button @click='fitBounds' class='btn w-100'>
        <span class='wrap-icon'>
          <i class="far fa-compress-arrows-alt" />
        </span>
      </button>
      <button @click='zoom(1)' class='btn zoom-out w-100'>
        <span class='wrap-icon'>
          <i class="far fa-plus" />
        </span>
      </button>
      <button @click='zoom(-1)' class='btn zoom-in w-100'>
        <span class='wrap-icon'>
          <i class="far fa-minus" />
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import buttonCopyLinkToClipboard from '../../components/copy_to_clipboard'
import buttonGetGeogridImage from '../components/geogrid_image'

export default {
  name: 'GeogridButtons',
  components: { buttonCopyLinkToClipboard, buttonGetGeogridImage },
  props: { geogridsPath: String },
  computed: {
    ...mapState(['geogrid', 'showOnMapComponents', 'pageTab'])
  },
  methods: {
    ...mapMutations(['repeatGeogrid', 'toggleOnMapComponents', 'fitBounds', 'zoom']),
    ...mapActions(['deleteGeogrid'])
  }
}
</script>
